import { render, staticRenderFns } from "./myPrivate.vue?vue&type=template&id=134a69ea"
import script from "./myPrivate.vue?vue&type=script&lang=js"
export * from "./myPrivate.vue?vue&type=script&lang=js"
import style0 from "./myPrivate.vue?vue&type=style&index=0&id=134a69ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports